<template>
  <!-- 历史成绩 -->

  <div>
    <!-- <div>
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <el-form-item label="关键字">
            <el-input v-model="formInline.user"
                      placeholder="请输入关键字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="onSubmit">查询</el-button>
            <el-button type=""
                       @click="onSubmit">重置</el-button>
          </el-form-item>
        </el-form>
      </div> -->
    <div class="head">
      <div>成绩列表</div>
      <div>
        <!-- <el-button type="primary"
                   @click="onAdd">添加试卷</el-button> -->
      </div>
    </div>
    <div style="margin-top:15px;">
      <el-table :data="tabData"
                border
                style="width: 100%">
        <el-table-column type="index"
                         align="center">
        </el-table-column>
        <el-table-column prop="studentName"
                         label="考生姓名"
                         align="center">
        </el-table-column>
        <el-table-column prop="studentNo"
                         label="学号"
                         align="center">
        </el-table-column>
        <el-table-column prop="className"
                         label="班级名"
                         align="center">
        </el-table-column>
        <el-table-column prop="schoolName"
                         label="校区"
                         align="center">
        </el-table-column>
        <el-table-column prop="startTime"
                         label="考试时间"
                         align="center">
        </el-table-column>
        <el-table-column prop="score"
                         label="成绩"
                         align="center">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <el-button size="mini"
                       @click="handleStart(scope.$index, scope.row)"
                       type="primary">历史成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: flex-end;margin-top: 15px;">
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :page-size="pamas.pageSize"
                       @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
    </div>
    <HistoryExam ref="HistoryExam"></HistoryExam>
  </div>
</template>
<script>
import { format } from "@/utils/datetime"
import HistoryExam from "./components/HistoryScore.vue"
export default {
  components: {
    HistoryExam
  },
  data () {
    return {
      formInline: {},
      tabData: [],
      total: 0,
      pamas: {
        examRecordId: "",
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created () {
    console.log(this.$route, 'd')
    let examRecordId = localStorage.getItem('examRecordId')||'';
    this.pamas.examRecordId = this.$route.query.id||examRecordId
    this.getScoreList(this.pamas)
  },
  methods: {
    pageSizeChangeHandle (val) {
      this.pamas.examRecordId = this.$route.query.id
      this.pamas.pageSize = val;
      this.pamas.pageNum = 1;
      this.getScoreList(this.pamas);
    },
    pageCurrentChangeHandle (val) {
      this.pamas.pageNum = val;
      this.getScoreList(this.pamas);
    },
    getScoreList (pamas) {
      this.$api.examCenter.getRecordListApi(pamas).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.tabData = res.data.list
          this.total = res.data.total
        }
      })
    },
    openDialog () {
      this.dialogVisible2 = true
    },
    //onSubmit () { },
    handleStart () {
      this.$refs.HistoryExam.openDialog()
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-dialog__header {
  text-align: left;
}
.head {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/ExamCenter/Score.vue